import Uri from 'jsuri';

import type { CartCreateOptions } from 'bundles/payments/common/types';
import courseraPlusSubscriptionsV1 from 'bundles/subscriptions-common/api/courseraPlusSubscriptionsV1';

export const createCart = (data: CartCreateOptions) => {
  const uri = new Uri().addQueryParam('action', 'createCart');

  return Promise.resolve(courseraPlusSubscriptionsV1.post(uri.toString(), { data }));
};

export const refund = (id: string) => {
  const uri = new Uri();
  uri.addQueryParam('action', 'refund');
  uri.addQueryParam('id', id);

  return Promise.resolve(courseraPlusSubscriptionsV1.post(uri.toString()));
};
